import React, { useState } from "react";
import firebase from "../firebase";
import { Link } from "react-router-dom";
import { Redirect } from "react-router";
import "bootstrap/dist/css/bootstrap.min.css";
import "./signup.css";

function Signup(props) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [username, setUsername] = useState("");

  console.log(props);

  const validation = (e) => {
    e.preventDefault();
    if (!email || !password || !username) {
      setError("All input fields are required! please provide valid inputs.");
      setSuccess("");
    } else {
      registerUser();
    }
  };
  const registerUser = () => {
    firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then((data) => {
        console.log(data.user.email, "is registerd successfully");
        setSuccess(`${data.user.email} is registerd successfully`);
        setError("");
      })
      .catch((err) => {
        console.log(err);
      });
    setPassword("");
    setEmail("");
    setUsername("");
  };

  if (props.location.state === "") {
    return (
      <div className="signup">
        {!props.user ? (
          <div className="main">
            <nav className="navbar navbar-light">
              <div className="container">
                <Link to="/" className="logo">
                  <h3 className="Navbar-brand">BLOGO</h3>
                </Link>
                <h6>Welcome! Register to continue</h6>
              </div>
            </nav>
            <div className="card container">
              <div className="alert alert-dark">
                <h6>Register with email!</h6>
              </div>
              <form className="container" onSubmit={validation}>
                <div className="form-group">
                  <label htmlFor="exampleInputUsername">Username</label>
                  <input
                    type="text"
                    className="form-control"
                    name="displayName"
                    id="exampleInputUsername"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Email address</label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <small id="emailHelp" className="form-text text-muted">
                    We'll never share your email with anyone else.
                  </small>
                </div>
                <div className="form-group">
                  <label htmlFor="exampleInputPassword1">Password</label>
                  <input
                    type="password"
                    name="password"
                    className="form-control"
                    id="exampleInputPassword1"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
                <button type="submit" className="btn btn-primary register-btn">
                  Register
                </button>
                <Link to="/">
                  <button type="submit" className="btn btn-primary">
                    Login
                  </button>
                </Link>
              </form>
              <br />
              {success !== "" ? (
                <div className="alert alert-success" role="alert">
                  {success}
                </div>
              ) : (
                ""
              )}
              {error !== "" ? (
                <div className="alert alert-danger" role="alert">
                  {error}
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        ) : (
          " "
        )}
      </div>
    );
  } else {
    return <Redirect to="/" />;
  }
}

export default Signup;
